export const products = $state({
  lAvailableTreatments: [], // de lijst die met de ajax call terug komt uit het backend (bIsAvailable, iPrice, sPriceString updated by Phase 2)
  lItems: [], // die l voor de naam is nog legacy.. het is een array
  oAvailabilityByProductID: {}, // volledige Phase-2 map, ook voor setleden buiten de zichtbare contentcategorieën
  aRecommendedProductIDs: [],
  aAvailableRestaurantTimes: [],

  // Phase 1: Content (HTML without availability)
  bIsFetchingTreatmentsContent: false,
  bHasTreatmentsContent: false,
  sTreatmentsContentHTML: '',

  // Phase 2: Availability - flags only (data is merged into lAvailableTreatments)
  bIsFetchingTreatmentsAvailability: false,
  bHasTreatmentsAvailability: false,

  // Last Phase 2 availability response, stamped with the params it was fetched for. Lets Phase 1
  // content that repopulates lAvailableTreatments AFTER Phase 2 re-merge the prices — but only when
  // the params still match the active booking (see importFromOfAjaxCall). Shape:
  // { sDate, iArrivalTime, iDepartureTime, iNrOfPeople, oData } or null.
  oLastTreatmentsAvailability: null,

  // Pending preselection: when a preselected treatment needs to wait for Phase 2 availability
  // This is set in addPerson() when iPreselectedTreatmentID exists but Phase 2 hasn't completed yet
  // NOTE: No person ID needed - preselected treatments are added to ALL people when Phase 2 completes
  iPendingPreselectedTreatmentID: false,

  // Pending user click: when user clicks "Toevoegen" before Phase 2 availability is ready
  // This is set by addProductWithAvailabilityCheck() when availability hasn't loaded yet
  // Object format: {iProductID, sPersonID} or {oProductSet, sPersonID}; false when not pending
  oPendingUserClickTreatment: false
});

window.hmk_products = () => {
  console.log($state.snapshot(products))
}

// Dev-only: forceer alle behandelingen op bIsAvailable=true.
// Zet de huidige state én een persistent flag, zodat ook toekomstige
// productsAvailability fetches (zie actions_remote.svelte.js) worden overschreven.
window.hmk_forceAvailable = () => {
  window.hmk_bForceAvailableTreatments = true;
  products.lAvailableTreatments.forEach(oCategory => {
    oCategory.lItems.forEach(oProduct => {
      oProduct.bIsAvailable = true;
    });
  });
  console.log('[DEV] Alle behandelingen geforceerd op bIsAvailable=true (geldt ook voor volgende availability calls). Roep hmk_forceAvailableOff() aan om uit te zetten.');
};

window.hmk_forceAvailableOff = () => {
  window.hmk_bForceAvailableTreatments = false;
  console.log('[DEV] Force-available uit. Navigeer terug naar stap 30 en weer vooruit voor een verse availability call.');
};
